import { render } from "./AyudaConfiguracionMFA.vue?vue&type=template&id=0c9f12dc&scoped=true"
import script from "./AyudaConfiguracionMFA.vue?vue&type=script&lang=js"
export * from "./AyudaConfiguracionMFA.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=0c9f12dc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9f12dc"]])

export default __exports__